
function MatchHeight() {
  $(".shop-by .nov-shop-by-cagegories .column-items .column_group>a").matchHeight();
  $(".shop-by .nov-shop-by-cagegories .column-items .title").matchHeight();
  $(".shop-by .nov-shop-by-cagegories .column-items .link-menu").matchHeight();  
  $(".product-related .product__price").matchHeight();

  $(".item-product .thumbnail-container").matchHeight();
  $(".item-product .product__info .product__title").matchHeight();
  $(".item-product .product__price").matchHeight();  
 $(".boost-pfs-filter-product-item-title").matchHeight(); 
}
function MatchHeight1() {

  // $(".item-product .thumbnail-container").matchHeight();
  // $(".item-product .product__info .product__title").matchHeight();
  // $(".item-product .product__price").matchHeight(); 
}

$(document).ready(function() {
  MatchHeight();  
});
$(window).load(function() {
  MatchHeight();
  jQuery(document).on("click", '.boost-pfs-filter-default-toolbar .boost-pfs-filter-toolbar-item.boost-pfs-filter-top-sorting', function(event) { 
      // console.log('filter');
      setInterval(function() {
        MatchHeight();               
      }, 1000);        
  });
  // setInterval(function() {MatchHeight1();}, 500);
});

var $number = $('#shopify-section-nov-product-template #Quantity');
$number.on('blur', function() {
    var $input = $(this);
    if ($input.val().trim() == '0') {
        $input.val('1');
    }
    if ($input.val() != $input.data('originalValue')) {
        // Put code to handle a change here.
    }
});


// $('a[data-toggle="tab"]').on("shown.bs.tab", function() {
//     setTimeout(function() {
//     MatchHeight();
//         $(".collection-carousel").slick("setPosition");
//     }, 100);
// });